import {
  FETCH_PACKAGES_PENDING,
  FETCH_PACKAGES_REJECTED,
  FETCH_PACKAGES_FULFILLED
} from "../constants/packages";

const initialState = {
  pending: true,
  packages: [],
  error: {}
};

export const packages = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PACKAGES_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PACKAGES_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PACKAGES_FULFILLED:
      return {
        ...state,
        packages: action.response.results,
        pending: false,
        error: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packages.js